import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";

export const useGestionLineasCategorias = () => {

    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };


    const [lineasConvocatorias, setLineasConvocatorias] = useState([]);
    const getLineasConvocatorias = async() => {
        try {
            const lineasConvocatorias = await apiMaestras.obtenerLineaConvocatoria();
            setLineasConvocatorias(lineasConvocatorias)
        } catch (error) {
            console.log(error)
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        getLineasConvocatorias,
        lineasConvocatorias
    } 
}
